var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      on: {
        scroll: function ($event) {
          return _vm.onScroll($event)
        },
      },
    },
    [
      _vm._t("before"),
      _vm._l(_vm.chunks, function (chunk) {
        return _c("v-chunk", {
          key: chunk.id,
          attrs: {
            "chunk-id": chunk.id,
            items: chunk.items,
            size: _vm.size,
            "upper-bound": _vm.upperBound,
            "lower-bound": _vm.lowerBound,
            refresh: _vm.refresh,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function (item) {
                  return [_vm._t("default", null, { item: item.item })]
                },
              },
            ],
            null,
            true
          ),
        })
      }),
      _vm._t("after"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }